import React, { useState } from "react";
import {
  Radio,
  RadioGroup,
  Typography,
  FormControlLabel,
  Snackbar
} from "@mui/material";
import Alert from "@mui/material/Alert";
import makeStyles from "@mui/styles/makeStyles";
import { useUpdateStatus } from "../../../../hooks/homework";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  formControlRoot: {
    marginRight: `${theme.spacing(3)} !important` // important necessary to override deeply nested material UI radio button styles
  },
  formControlLabel: {
    marginLeft: "0 !important"
  }
}));

const HomeworkStatus = ({ rowData, trainingObjectId, isIlt }) => {
  const [status, setStatus] = useState(rowData.status);
  const updateStatus = useUpdateStatus(trainingObjectId, rowData.id);
  const [open, setOpen] = useState(false);
  const [updateResponse, setUpdateResponse] = useState();
  const { t } = useTranslation();
  const classes = useStyles();
  const handleChange = async e => {
    const value = e.target.value;
    const success = await updateStatus({ status: value });
    if (success) {
      setUpdateResponse(
        <Alert serverity="success">
          {value === "rejected" && !isIlt
            ? t("homeworkSubmission.statusRejected")
            : t("homeworkSubmission.statusSaved")}
        </Alert>
      );
      setStatus(value);
      setOpen(true);
    } else {
      setUpdateResponse(
        <Alert serverity="error">{t("homeworkSubmission.statusFailed")}</Alert>
      );
      setOpen(true);
    }
  };
  return (
    <>
      <RadioGroup
        aria-label="accept/reject"
        name="accept/reject"
        value={status}
        onChange={handleChange}
        row
      >
        <FormControlLabel
          value="accepted"
          control={<Radio color="primary" />}
          label={
            <Typography variant="body2">
              {t("homeworkSubmission.accept")}
            </Typography>
          }
          classes={{
            root: classes.formControlRoot,
            label: classes.formControlLabel
          }}
        />
        <FormControlLabel
          value="rejected"
          control={<Radio color="primary" />}
          label={
            <Typography variant="body2">
              {t("homeworkSubmission.reject")}
            </Typography>
          }
          classes={{
            root: classes.formControlRoot,
            label: classes.formControlLabel
          }}
        />
      </RadioGroup>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
      >
        {updateResponse}
      </Snackbar>
    </>
  );
};

export default HomeworkStatus;
